import openModal from "../../../Calendar/openModal";

export default (formId: string) =>
  new Promise((resolve) => openModal(formId, () => resolve(true)));
